export default "__VITE_ASSET__D0EGeKmQ__"